<div class="image-container">
  @for (url of avatarPathUrls; track url; let i = $index) {
    <img [src]="url" class="part-image" [style.zIndex]="i" />
  }
</div>
